






























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { State, Action, Getter, namespace } from 'vuex-class'
import { queryMytopicGroup } from '@/api/exam/myTopicGroup'
import { NewPageParam, NewPage } from '@/model/common/newPage'
import TopicGroup from '@/model/exam/topicGroup'

// import {
//   QueryMyTopicGroupParam,
//   MyTopicGroup
// } from '@/model/exam/my_topic_group'

import MyTopicGroup from '@/model/exam/myTopicGroup'
import { QueryMyTopicGroupParam } from '@/api/exam/myTopicGroup'
import { log } from 'util'
import { queryTopicGroup, queryAllTopicGroup } from '@/api/exam/topicGroup'
import moment from 'moment'
import { TopicCategory } from '@/model/exam/topicGroup'
import EmployeeHistory from '@/apps/ice/components/EmployeeHistory.vue'
interface Paging {
  pageSize?: number
  current?: number
  total?: number
}

export interface MyTopicGroupModel {
  id: string
  name?: string
  companyId?: string
  duration?: number
  modelStatusTxt?: string
  topicGroupId?: string
  topicGroupType?: string
  topicCategory?: TopicCategory
  gmtCreated?: string
  gmtModified?: string
  useTime?: number
  resultScore?: number
  startTime?: string
  endTime?: string
  //前端新加属性
  topicCategoryTxt?: string
  key?: string
  durationTxt?: string
  useTimeTxt?: string
  modeTxt?: string
  reExam?: boolean
}

const TOPIC_CATEGORY_TXT: any = {
  TEST: '测试题',
  PROGRAM: '编程题'
}

const STATUS_TXT: any = {
  PASS: '通过',
  UNPASS: '未通过'
}

const TOPIC_GROUP_TYPE_TXT: any = {
  PRACTICE: '练习',
  TEST: '测试'
}
@Component({
  components: {
    EmployeeHistory
  }
})
export default class MyTopicGroupVue extends Vue {
  private spinShow: boolean = false
  private visible: boolean = false
  private topicGroupId?: string = ''
  private pagination: Paging = {
    pageSize: 10,
    current: 1,
    total: 0
  }
  private loading: boolean = false
  private data: MyTopicGroupModel[] = []
  private myTopicGroupModelList: NewPage<MyTopicGroupModel> = {
    pagination: 0,
    pageSize: 10,
    totalCount: 0,
    totalPage: 1,
    data: []
  }
  async mounted() {
    this.spinShow = false
    this.requestMyData()
  }

  private async requestTopicGroupPage(): Promise<TopicGroup[]> {
    return await queryAllTopicGroup({
      status: 'PUBLISHED'
    })
  }

  openHistory() {
    this.visible = true
  }
  closeHistory() {
    this.visible = false
  }

  private async requestMyTopicGroupList(
    topicGroupIds: string[]
  ): Promise<MyTopicGroup[]> {
    let myTopicGroupPage: NewPage<MyTopicGroup> = await queryMytopicGroup({
      topicGroupIds: topicGroupIds,
      pagination: 0,
      pageSize: 1000,
      companyId: '5e4603b9457bfa3cd245c359'
    })
    return myTopicGroupPage.data || []
  }

  private async requestMyData() {
    this.loading = true
    const topicGroupData = await this.requestTopicGroupPage()
    const topicGroupList = topicGroupData
    const topicGroupIdList =
      (topicGroupList && topicGroupList.map(topicGroup => topicGroup.id!)) || []
    const myTopicGroupList = await this.requestMyTopicGroupList(
      topicGroupIdList
    )
    this.data = this.handleData(topicGroupList || [], myTopicGroupList)
    this.loading = false
    this.$forceUpdate()
  }

  // private async handleTableChange(pagination: any) {
  //   this.pagination = pagination
  //   this.requestMyData()
  // }

  /**
   * 处理数据
   */
  private handleData(
    topicGroupList: TopicGroup[],
    rawMyTopicGroupList: MyTopicGroup[]
  ) {
    const myTopicGroupMap: any = {}
    rawMyTopicGroupList.map(item => {
      const topicGroupId: string = item.topicGroup!.id!
      if (!myTopicGroupMap[topicGroupId]) {
        myTopicGroupMap[topicGroupId] = []
      }
      myTopicGroupMap[topicGroupId].push(item)
    })

    const myTopicGroupModels: MyTopicGroupModel[] = []
    topicGroupList.map((topicGroup: TopicGroup) => {
      //@ts-ignore
      let myTopicGroupModel: MyTopicGroupModel = {
        ...topicGroup,
        topicCategoryTxt: TOPIC_CATEGORY_TXT[topicGroup.topicCategory!],
        modeTxt: TOPIC_GROUP_TYPE_TXT[topicGroup.mode!],
        durationTxt: topicGroup.duration + '分钟',
        topicGroupId: topicGroup.id
      }

      let myTopicGroupList = myTopicGroupMap[topicGroup.id!] || []
      myTopicGroupList.sort((a: MyTopicGroup, b: MyTopicGroup) => {
        if (moment(a.endTime) > moment(b.endTime)) {
          return -1
        }
        return 1
      })
      myTopicGroupModel.modelStatusTxt = '未开始'
      const lastMyTopicGroup = myTopicGroupList[0]
      if (lastMyTopicGroup) {
        myTopicGroupModel.modelStatusTxt = STATUS_TXT[lastMyTopicGroup.status!]
        myTopicGroupModel.endTime = lastMyTopicGroup.endTime
        myTopicGroupModel.startTime = lastMyTopicGroup.startTime
        myTopicGroupModel.resultScore = lastMyTopicGroup.resultScore
        myTopicGroupModel.useTimeTxt = `${Math.ceil(
          (lastMyTopicGroup.useTime || 0) / 60
        )}分钟`
        myTopicGroupModel.reExam = lastMyTopicGroup.reExam
      }
      myTopicGroupModels.push(myTopicGroupModel)
    })

    return myTopicGroupModels || []
  }

  private handlePass(text: any, myTopicGroupModel: any) {
    this.visible = true
    this.topicGroupId = myTopicGroupModel.topicGroupId
  }
  private handleUnPass(text: any, myTopicGroupModel: any) {
    this.$router.push(
      `/topic?topicGroupId=${myTopicGroupModel.topicGroupId}&reAnswer=true`
    )
  }
  private handleTodo(text: any, myTopicGroupModel: any) {
    var currentWwwPath = window.document.location.origin
    if ('PROGRAM' === myTopicGroupModel.topicCategory) {
      let path = `${currentWwwPath}/program/${myTopicGroupModel.id}/0/0/0`
      window.open(`${currentWwwPath}/program/${myTopicGroupModel.id}/0/0/0`)
    } else {
      window.open(
        `${currentWwwPath}/topic?topicGroupId=${myTopicGroupModel.topicGroupId}&reAnswer=false`
      )
    }
  }

  private columns = [
    {
      title: '考试名称',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '考试类型',
      dataIndex: 'topicGroupType',
      key: 'topicGroupType'
    },
    {
      title: '题目形式',
      dataIndex: 'modeTxt',
      key: 'modeTxt'
    },
    {
      title: '考试状态',
      key: 'modelStatusTxt',
      scopedSlots: {
        customRender: 'modelStatusTxt'
      }
    },
    {
      title: '考试时间(分)',
      dataIndex: 'durationTxt',
      key: 'durationTxt'
    },
    {
      title: '答题开始时间',
      dataIndex: 'startTime',
      key: 'startTime'
    },
    {
      title: '答题耗时',
      dataIndex: 'useTimeTxt',
      key: 'useTimeTxt'
    },
    {
      title: '考试得分',
      dataIndex: 'resultScore',
      key: 'resultScore'
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }
  ]
}
